import { Box, Collapse, Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Info, Close as CloseIcon } from '@material-ui/icons';
import IncompleteVitrineIcon from 'components/Icons/IncompleteVitrine';
import { useRouter, useAuth } from '@webapps/reactjs-tech-components';
import { ROUTES_PATH } from 'config/constants';
import { useStyles } from '@webapps/styles';

const IncompleteVitrine = ({ open, setOpen }) => {

    const { classes, css, theme: { spacing, fontSizes } } = useStyles(styles);
    const { profile } = useAuth();
    const { push } = useRouter();

    return <div>
        <Collapse in={open} className={classes.collapse}>
          <Box className={classes.alertBox}>
            <div style={{ display: 'flex' }} className={css({'@media (max-width:600px)': { width: "100%" }})}>
              <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                <IncompleteVitrineIcon className={classes.alertInfo} />
              </div>
              <div style={{ color: '#152652' }}>
                <p className={classes.alertTitle}><FormattedMessage id='business.dashboard.incompleteVitrine.title' /></p>
                <p className={classes.alertText}><FormattedMessage id='business.dashboard.incompleteVitrine.subtitle' /></p>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }} className={css({'@media (max-width:600px)': { width: "100%" }})}>
              <Button
                aria-label="close"
                onClick={() => {
                    if(profile === "BUSINESS")
                        push(ROUTES_PATH.EDIT_Business_VITRINE)
                    else
                        push(ROUTES_PATH.EDIT_SCHOOL_VITRINE)
                }}
                size="small"
                className={classes.button}
              >
                Corriger
              </Button>
            </div>
          </Box>
        </Collapse>
    </div>
}

const styles = ({ spacing, fontSizes }) => ({
    alertBox: {
        backgroundColor: '#FFF',
        border: '3px solid #0060F9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '10px',
        padding: "10px",
        flexWrap: 'wrap',
    },
    button: {
        padding: '5px 40px',
        marginRight: '15px',
        backgroundColor: '#0060F9',
        '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
        color: "#FFF",
        "&:hover": {
            backgroundColor: "rgb(0, 67, 174)",
        },
        '@media (max-width:1400px)': { padding: '5px 20px' },
        '@media (max-width:600px)': { width: "100%", marginRight: "0" }
    },
    alertContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        '@media (max-width:1309px)': { flexDirection: "column" },
    },
    alertInfo: {
        fontSize: '50px',
        margin: '0 20px',
    },
    alertTitle: {
        '@media only screen and (max-width:1920px)': {fontSize: '15.00px'}, '@media only screen and (max-width:1600px)': {fontSize: '14.00px'},
        marginBottom: spacing(2),
        fontFamily: 'Montserrat',
        fontWeight: 600
    },
    alertText: {
        '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
        marginTop: 0,
        fontFamily: 'Roboto',
        color: "#5D75A8"
    },
    collapse: {
      marginBottom: spacing(2),
        '@media (max-width:1220px)': { width: "100%" },
        '@media (max-width:768px)': { marginTop: "20px" },
        width: "50%",
    }
});

export default IncompleteVitrine